import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";

import columns from "./Table/columns";
import data from "./Table/data";

import { useEditCoachPoolContext } from "../../../../contexts/EditCoachPoolContext";
import { useMultiFilterContext } from "../../../../contexts/MultiFilterContext";

export default function Table() {
  const { dispatch, actions, state } = useEditCoachPoolContext();
  const { state: stateFilter } = useMultiFilterContext();

  const conditionalRowStyles = [
    {
      when: (row) => state.coachSelected.includes(row.id),
      style: {
        backgroundColor: "#8CD3EC",
        color: "#FFFFFF",
      },
    },
  ];

  useEffect(() => {
    actions.loadCoaches(dispatch);
  }, []);

  return (
    <>
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns(actions, dispatch, state, stateFilter)}
          data={data(state, stateFilter) || []}
          noDataComponent={
            <div className="mt20">
              {state.coaches == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
          conditionalRowStyles={conditionalRowStyles}
        />
      </div>
    </>
  );
}
